module.exports = __webpack_public_path__ + "img/background-tablet-default.47833fe0.png";